export default __webpack_public_path__ + "static/media/2007.a0fc5138.png";